import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

/** @class EditorDialog
  * A component for displaying a dialog
  * @prop {boolean} show - true to display dialog; false to hide
  * @prop {function} onExit - a callback triggered when the dialog's
  * close button is clicked.
  */
export default class EditorDialog extends Component {
  /** @method render
    * Renders the component
    */
  render() {
    if(!this.props.show) return null;
    return (
      <div>
        <div className="dialog-mask"></div>
        <div className="dialog-wrapper">
          <div className="dialog">
            <div className="dialog-close">
              <button onClick={this.props.onExit}><FontAwesome name="times"/></button>
            </div>
            <div>
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EditorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/editor-components/editor-dialog.js